export default "__VITE_ASSET__DMPv5Swr__"